module.exports = __webpack_public_path__ + "static/media/megablob.47a026b8.svg";